import cx from 'classnames';

import cypressIds from 'Components/cypress_ids.json';
import { NumericGradingText } from 'Components/NumericGradingText/NumericGradingText';
import type { NumericGradeValues } from 'Pages/vehicles/helpers/vehicle.schema';
import { triggerGradingModalClosedEvent, triggerGradingModalOpenedOrClosedEvent } from 'Services/analytics/events';

import { VehicleSpecsDetailsButton } from '../../../MotSection/VehicleSpecsDetailsButton/VehicleSpecsDetailsButton';

import { ExteriorNumericGradingModal } from './ExteriorGrading/ExteriorNumericGradingModal/ExteriorNumericGradingModal';

import styles from './VehicleDetailsExteriorGrading.module.scss';

interface VehicleDetailsExteriorNumericGradingProps {
	numericGrade: NumericGradeValues;
}

export const VehicleDetailsExteriorNumericGrading: React.FC<VehicleDetailsExteriorNumericGradingProps> = ({
	numericGrade,
}) => {
	return (
		<div className={cx(styles.container)}>
			<NumericGradingText grade={numericGrade} size={'regular'} />
			<VehicleSpecsDetailsButton
				cypressId={cypressIds.links.gradingDetails}
				modal={<ExteriorNumericGradingModal />}
				onModalClose={() => {
					triggerGradingModalClosedEvent();
				}}
				onModalOpen={() => {
					triggerGradingModalOpenedOrClosedEvent(true);
				}}
			/>
		</div>
	);
};
